import { render, staticRenderFns } from "./PanelBrand.vue?vue&type=template&id=dd6be9e8&"
import script from "./PanelBrand.vue?vue&type=script&lang=js&"
export * from "./PanelBrand.vue?vue&type=script&lang=js&"
import style0 from "./PanelBrand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports